import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchAllTemplates,
  fetchTemplateDetails,
  createTemplate,
  deleteTemplate,
} from "services/ordtemplate";

export const useAllTemplates = (vendorId) => {
  return useQuery({
    queryKey: ["ordtemplates", vendorId || ""],
    queryFn: () => fetchAllTemplates(vendorId),
    staleTime: 1000 * 60 * 5,
  });
};

export const useTemplateDetails = (templateId, enabled = true) => {
  return useQuery({
    queryKey: ["ordtemplate-details", templateId],
    queryFn: () => fetchTemplateDetails(templateId),
    enabled: !!templateId && enabled,
  });
};

export const useCreateTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createTemplate(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["ordtemplates"] });
    },
  });
};

export const useDeleteTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteTemplate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["ordtemplates"] });
    },
  });
};
